import striptags from 'striptags';
function striptagsFromObject(object) {
  if (typeof object === 'string') {
    return striptags(object);
  }
  if (object === null || object === undefined) {
    return object;
  }
  if (Array.isArray(object)) {
    return object.map(striptagsFromObject);
  }
  if (typeof object === 'object') {
    return Object.fromEntries(Object.entries(object).map(_ref => {
      let [k, v] = _ref;
      return [k, striptagsFromObject(v)];
    }));
  }
  return object;
}
export default striptagsFromObject;